import axios from "axios";
import Linkify from "linkify-react";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { FaRegFile } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";
import Laoding from "../../../components/Loading";
import PaginateCard from "../../../components/PaginateCard";
import { getByAuthService } from "../../../function/helper";
import dateTimeToJalali from "../../../function/jalali/dateTimetoJalali";
import useMessageTicket from "../../../hooks/useMessageTicket";
import useSharedData from "../../../hooks/useSharedData";
import backendUrl from "../../../utilities/backendUrl";
import baseUrl from "../../../utilities/baseUrl";
import style from "./MessageGrid.module.css";

function MessageGrid() {
  const [searchParams, setSearchParams] = useSearchParams({ page: 1 });

  const [loading, setLoading] = useState(true);
  const { user } = useSharedData();
  const { reduceUnreadMessage } = useMessageTicket();
  const [messages, setMessages] = useState([]);
  const [count, setCount] = useState(0);

  const getData = async () => {
    setLoading(true);
    const response = await getByAuthService(
      `/messages/v1/show?is_read=1&page=${searchParams.get("page")}`
    );
    setLoading(false);

    if (response && response.status === 200) {
      setMessages(() => response.data.result);
      setCount(response.data.count);
    }
  };

  const readMessage = async (messageId, idx) => {
    const response = await axios.put(
      `${baseUrl}/messages/v1/edit?message_id=${messageId}&user_id=${user.id}`
    );

    if (response.status === 200) {
      reduceUnreadMessage(messageId);

      setMessages(curr => {
        return curr.map((item, index) => {
          if (index === idx) {
            return { ...item, is_read: 1 };
          } else {
            return item;
          }
        });
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Container dir="rtl" className="my-4">
      <h4 className="text-end my-5">
        لطفا پیام های خود را مطالعه کنید و دکمه ی متوجه شدم را بزنید.
      </h4>

      {loading && <Laoding />}

      {!loading &&
        messages.map((item, idx) => (
          <article className={style.box} key={idx}>
            <div className="p-3">{item.message.title}</div>

            <div className="position-relative">
              <div
                className={"text-end fw-normal " + style.container}
                style={{ whiteSpace: "pre-line" }}
              >
                <Linkify options={{ target: "_blank" }}>
                  {item.message.body}
                </Linkify>
              </div>

              {item.is_read === 0 && (
                <button
                  className={style.btn}
                  onClick={() => readMessage(item.message.id, idx)}
                >
                  متوجه شدم
                </button>
              )}

              {item.message.files?.length > 0 && (
                <div className="d-flex flex-column pb-0">
                  {item.message.files?.map((file, index) => (
                    <Link
                      className="my-1"
                      to={backendUrl + file.fileName}
                      download={true}
                      target="_blank"
                      rel="noreferrer"
                      key={index}
                    >
                      <FaRegFile />
                      <span className="me-2">فایل شماره‌ی {index + 1}</span>
                    </Link>
                  ))}
                </div>
              )}

              <p className={style.time}>
                <span>
                  {dateTimeToJalali(item.message.created_at).shortTime}
                </span>
                <span> - </span>
                <span>{dateTimeToJalali(item.message.created_at).date}</span>
              </p>
            </div>
          </article>
        ))}

      <PaginateCard
        className="mt-5"
        count={count}
        numberItems={10}
        numberPage={searchParams.get("page")}
        onIndexChoose={number => {
          setSearchParams(cur => {
            cur.set("page", number);
            return cur;
          });
          getData();
        }}
      />
    </Container>
  );
}

export default MessageGrid;
